import { Button, Col, Modal, notification, Row, Tooltip } from "antd";
import { ReactComponent as IconUpload } from "../../../assets/images/upload-border.svg";
import imgDocument from "../../../assets/images/document_download.svg";
import imgTickRight from "../../../assets/images/tickRight.svg";
import imgLoading from "../../../assets/images/loading.svg";
import wrong from "../../../assets/images/wrong.svg";
import { ReactComponent as IconLock } from "../../../assets/images/lock_border.svg";
import BSAInputItem from "./BSAInputItem";
import AppUpload from "../Lead/AppUpload/app-upload";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  addDocumentCommon,
  getUnreadNotificationCount,
  getUserDetails,
} from "shared/services/Utility";
import API_SERVICE from "shared/services/api-service";
import AppLoading from "../AppLoading/AppLoading";
import "./BSAInput.scss";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import BankStatement from "../LeadNew/LeadDetail/BankStatement";
import { setNotificationCount } from "shared/redux/notificationCount-reducer";
import { setIsBankAnalysisRequired } from "shared/redux/common-reducer";
import CloseWarningBSA from "./CloseWarningBSA";

interface IBSAInput {
  actionBack?: () => void;
  leadData?: any;
  closeWarningBSALocation: string;
  setCloseWarningBSAlocation: Dispatch<SetStateAction<string>>;
}

const BSAInput: React.FC<IBSAInput> = (props: IBSAInput) => {
  const { actionBack, leadData, closeWarningBSALocation, setCloseWarningBSAlocation } = props;

  const [loading, setLoading] = useState(false);
  const [fileSize, setFileSize] = useState(false);
  const [uploadDocumentList, setUploadDocumentList] = useState({
    sucess: [],
    failed: [],
  } as any);
  const [popupVisible, setPopupVisible] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null as any);
  const [selectedDocs, setSelectedDocs] = useState([] as any);
  const [documentList, setDocumentList] = useState([] as any);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState(
    "ADD_FILE" as "ADD_FILE" | "RUN_ANALYSIS"
  );
  const [bankList, setBankList] = useState([] as any);
  const [isFinBox, setIsFinBox] = useState(false);
  const [showMsgAnalysis, setShowMsgAnalysis] = useState(false);
  const [msgAnalysis, setMsgAnalysis] = useState("");

  const dispatch = useDispatch();
  const { isMobile, appColors }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const bsaProvider = tenantInfo?.bsaConfiguration?.bsaProvider;

  const documentSetId =
    leadData?.caseDetails?.documentSetId ?? getUserDetails()?.documentSetId;
  const noOfMonths = leadData?.masterProductActionConfigurations?.find(
    (con: any) => con?.actionId == "BANK_STATEMENT_ANALYSIS"
  )?.noOfMonths;

  useEffect(() => {
    if (bsaProvider == "DISABLED") {
      notification.error({
        message:
          "The Bank Statement Analysis feature is currently disabled. Contact the administration team to enable it",
      });
    } else {
      if (bsaProvider == "FINBOX") {
        getShowFinboxStatus();
        // un comment when open from vas action
      }
      if(bsaProvider == "VMT") {
        getDocumentList(false, true);
        getDocumentBankData();
      }
    }
  }, [bsaProvider]);

  const getDocumentList = (onlyListing: boolean, reCall?: boolean) => {
    if (!leadData?.caseDetails?.caseId) {
      setLoading(false)
      return;
    }
    setLoading(true);
    API_SERVICE.getBSADocumentList(leadData?.caseDetails?.caseId, onlyListing)
      .then(({ data }) => {
        if (data) {
          const docCatFilter = data?.payload?.documentConfigDetails?.filter(
            (docCat: any) => docCat?.documentCategoryName == "Bank Statements"
          );
          const docList = docCatFilter
            ?.at(0)
            ?.documentTypeWithUploadedDetails?.filter(
              (doc: any) =>
                doc?.documentTypeType == "BANK_STATEMENT" &&
                doc?.documentDetails
            );
          const sortedList = docList.sort((a, b) =>
            a.documentDetails.documentDate > b.documentDetails.documentDate ? 1 : -1
          );
          setDocumentList(sortedList ?? []);
        }
      })
      .catch((e: any) => {
        if(reCall) {
          getDocumentList(true);
        } else {
          notification.error({ message: API_SERVICE.handleErrors(e) });
        }
      })
      .finally(() => setLoading(false));
  };

  const getDocumentBankData = () => {
    API_SERVICE.getBSAListBanks(false, {isValidForAnalysis: bsaProvider == "VMT"})
      .then(({ data }) => {
        if (data?.payload) {
          const updtedData: any = [];
          data?.payload?.banks?.map((item: any) => {
            if(item?.validForAnalysis) {
              updtedData.push({
                label: item?.name,
                value: item?.code,
              });
            }
          });
          setBankList(updtedData);
        }
      })
      .catch((e) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const getShowFinboxStatus = () => {
    setLoading(true);
    setIsFinBox(false);
    API_SERVICE.getShowFinboxStatus()
      .then(({ data }) => {
        if (data?.payload) {
          setIsFinBox(true);
        } else {
          getAnalysisCheck();
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setLoading(false));
  };

  const getAnalysisCheck = () => {
    setLoading(true);
    API_SERVICE.getAnalysisCheck(leadData?.caseDetails?.caseId)
      .then(({ data }) => {
        if ((data?.payload?.disclaimerMessage?.length ?? 0) > 0) {
          setShowMsgAnalysis(true);
          setMsgAnalysis(data?.payload?.disclaimerMessage);
        } else {
          setLoading(false);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        setLoading(false);
      });
  };

  let tmp : any = [...documentList];
  const uploadDocumtnt = async (file, data) => {
    setLoading(true)
    const fileSize = file?.size ? (file?.size / 1024 / 1024).toFixed(2) : null;
    const response = await addDocumentCommon(
      documentSetId,
      data,
      file.name,
      "BANK_STATEMENT",
      "BANK_STATEMENT",
      fileSize
    );
    setLoading(false)
    setSelectedDocs([]);
    dispatch(setIsBankAnalysisRequired(true));
    if (!leadData?.caseDetails?.caseId) {
      tmp = [
        ...tmp,
        {
          appliedFileTypes: ["JPEG", "PDF", "XLSX", "PNG"],
          maximumSizeInMB: 10,
          documentDetails: response?.payload,
        },
      ];
      setDocumentList(tmp);
    } else {
      getDocumentList(true);
    }
  };

  const bsaAnalyse = () => {
    const params = {
      caseId: leadData?.caseDetails?.caseId,
      businessDocumentIds: selectedDocs,
      numberOfMonthsForAnalysis: noOfMonths,
    };
    notification.success({
      message:
        "Your task is in progress and may take some time. You will get the output on the Output Tab.",
    });
    dispatch(setIsBankAnalysisRequired(false));
    API_SERVICE.bsaAnalyse(params)
      .then(({ data }) => {
        setSelectedDocs([]);
        getUnreadNotificationCount(dispatch, setNotificationCount);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const renderUploadedDocumentPopup = () => {
    return (
      <Modal
        className="model-document-upload"
        visible={popupVisible}
        footer={null}
        onCancel={() => {
          setPopupVisible(false);
          setUploadDocumentList({ sucess: [], failed: [] });
        }}
        mask={false}
      >
        <Row className="header">
          <Col span={24} className="header-title">
            Uploaded {uploadDocumentList.sucess.length} out of{" "}
            {Number(uploadDocumentList.sucess.length) +
              Number(uploadDocumentList.failed.length)}{" "}
            Files
          </Col>
        </Row>
        {uploadDocumentList?.sucess?.map((items: any, index: any) => {
          return (
            <Row className="document-content" key={`doc_${index}`}>
              <Col span={2} className="doc-cols">
                <img src={imgDocument} />
              </Col>
              <Col span={13} className="doc-cols">
                <span className="document-name">{items?.name}</span>
              </Col>
              <Col span={6} className="doc-cols">
                <div className="document-size">{(items?.size/1024).toFixed(2)}KB</div>
              </Col>
              <Col span={3} className="doc-cols">
                {items.status === "Done" ? (
                  <img src={imgTickRight} height={30} width={30} />
                ) : (
                  <img
                    className="loading-img"
                    src={imgLoading}
                    height={30}
                    width={30}
                  />
                )}
              </Col>
            </Row>
          );
        })}
        {uploadDocumentList?.failed?.map((items: any, index: any) => {
          return (
            <Row className="document-content" key={`doc_${index}`}>
              <Col span={2} className="doc-cols">
                <img src={imgDocument} />
              </Col>
              <Col span={13} className="doc-cols">
                <span className="document-name">{items?.name}</span>
              </Col>
              <Col span={6} className="doc-cols">
                <div className="document-size">{(items?.size/1024).toFixed(2)}KB</div>
              </Col>
              <Col span={3} className="doc-cols">
                <img src={wrong} height={30} width={30} />
              </Col>
            </Row>
          );
        })}
      </Modal>
    );
  };

  const renderAppUload = () => {
    if (bsaProvider == "DISABLED") {
      return (
        <Button className="app-btn-secondary-border BSA-disable">
          <IconUpload />
          Upload
        </Button>
      );
    } else if (bsaProvider == "FINBOX") {
      return (
        <Button
          className="app-btn-secondary-border"
          onClick={() => {
            getShowFinboxStatus();
          }}
        >
          <IconUpload />
          Upload
        </Button>
      );
    }

    return (
      <AppUpload
        showLoader
        acceptType={["pdf"]}
        showUploadList={false}
        multiple
        maxSize={10}
        setPopupVisible={setPopupVisible}
        popupVisible={popupVisible}
        uploadDocumentList={uploadDocumentList}
        setUploadDocumentList={setUploadDocumentList}
        callBack={(response, uploadDocumentList) => {
          if (response?.data && response?.file) {
            setUploadedFile(response?.file);
            uploadDocumtnt(response?.file, response?.data);
          }
        }}
        className=""
        setFileSize={setFileSize}
        setUploadedFile={setUploadedFile}
        setIsSelectedLenderDoc={undefined}
      >
        <Button className="app-btn-secondary-border">
          <IconUpload />
          Upload
        </Button>
      </AppUpload>
    );
  };

  const renderConfirm = () => {
    return (
      <Modal
        visible={showConfirm}
        closable={false}
        footer={null}
        width={400}
        centered
      >
        <div className="delete-modal">
          <span>
            {confirmType == "ADD_FILE"
              ? "Do you want to add more files to your analysis?"
              : `Recommended months for analysis are ${noOfMonths}. Are you sure you want to run the analysis with these files?`}
          </span>
          <div className="delete-modal-btn">
            <Button
              className="app-btn-border"
              style={
                {
                  "--btnColor":
                    confirmType == "ADD_FILE" ? "#c71c8e" : "#273896",
                } as any
              }
              onClick={() => {
                if (confirmType == "ADD_FILE" && noOfMonths > 0) {
                  setConfirmType("RUN_ANALYSIS");
                } else {
                  bsaAnalyse();
                  setShowConfirm(false);
                }
              }}
            >
              {confirmType == "ADD_FILE" ? "No" : "Yes"}
            </Button>
            <Button
              className="app-btn-primary-bg"
              onClick={() => setShowConfirm(false)}
            >
              Add More Files
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const renderDocuments = () => {
    return (
      <>
        {!isMobile && (
          <div className="BSA-II-document BSA-II-document-header">
            <div className="BSA-II-file-name" style={{ display: "flex" }}>
              File name
            </div>
            <div className="BSA-II-format">
              Format
              <Tooltip title="The document should be a native PDF">
                <InfoCircleOutlined />
              </Tooltip>
            </div>
            <div className="BSA-II-maxsize">
              File size
              <Tooltip title="The file size should be less than 10MB">
                <InfoCircleOutlined />
              </Tooltip>
            </div>
          </div>
        )}
        {documentList?.map((doc: any, index: number) => {
          return (
            <BSAInputItem
              key={`doc-${doc?.documentDetails?.businessDocumentId}`}
              document={doc}
              setSelectedDocs={setSelectedDocs}
              selectedDocs={selectedDocs}
              bankList={bankList}
              callBackDelete={() => {
                tmp = documentList.filter((document: any) => document?.documentDetails?.businessDocumentId != doc?.documentDetails?.businessDocumentId);
                setDocumentList(tmp);
                setLoading(false)
              }}
              setLoading={setLoading}
              caseId={leadData?.caseDetails?.caseId}
              employerName={leadData?.dsaCaseAdditionalAttributes?.employerName}
            />
          );
        })}
      </>
    );
  };

  const renderBankStatement = () => (
    <BankStatement
      setIsFinBox={setIsFinBox}
      leadData={leadData}
      isFinBox={isFinBox}
      getVASActionStatus={() => {
        setLoading(false)
        // getDocumentList(true);
      }}
      setIsLoading={setLoading}
    />
  );

  const modalBtnPrimaryStyles: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    width: "140px",
  };

  const renderVASActionModal = () => {
    return (
      <Modal
        title=""
        centered
        width={400}
        closable={false}
        footer={null}
        visible={showMsgAnalysis}
      >
        <div className="p-10">
          <div style={{ textAlign: "center" }}>{msgAnalysis}</div>
          <div className="h-center p-10">
            <Button
              className="dynamic-btn-primary"
              style={modalBtnPrimaryStyles}
              size="large"
              type="primary"
              onClick={() => setShowMsgAnalysis(false)}
            >
              OK
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div>
      {closeWarningBSALocation?.length > 0 && (
        <CloseWarningBSA
          closeWarningBSALocation={closeWarningBSALocation}
          setCloseWarningBSAlocation={setCloseWarningBSAlocation}
          callBack={(newlocation) => {
            if (actionBack) {
              actionBack();
            }
          }}
        />
      )}
      {isFinBox && renderBankStatement()}
      {showMsgAnalysis && renderVASActionModal()}
      {renderConfirm()}
      <div className="document-upload">{renderUploadedDocumentPopup()}</div>
      <div className="BSA-II-header">
        <div className="BSA-header-title">
          <span className={bsaProvider == "DISABLED" ? "BSA-disable" : ""}>
            Bank Statement Analysis
          </span>
          {noOfMonths > 0 && (
            <span
              className={`BSA-doc-month-req ${
                bsaProvider == "DISABLED" ? "BSA-disable" : ""
              }`}
            >
              {`${noOfMonths} Months Statement Required`}
            </span>
          )}
          {bsaProvider == "DISABLED" && (
            <IconLock
              onClick={() => {
                notification.error({
                  message:
                    "The Bank Statement Analysis feature is currently disabled. Contact the administration team to enable it",
                });
              }}
            />
          )}
        </div>
        {renderAppUload()}
      </div>
      {bsaProvider == "VMT" && renderDocuments()}
      {bsaProvider == "FINBOX" && 
        <div style={{fontWeight:'300', marginBlock:'30px', textAlign:'center'}}>
          Please click on “Upload Button” to initiate the Bank statement Analyzer widget
        </div>
      }
      <div className="footer-btn">
        {bsaProvider == "VMT" && (
          <Button
            className="app-btn-primary-bg"
            disabled={(selectedDocs?.length ?? 0) == 0}
            onClick={() => {
              setConfirmType("ADD_FILE");
              setShowConfirm(true);
            }}
          >
            Continue
          </Button>
        )}
       
      </div>
      {loading && <AppLoading />}
    </div>
  );
};

export default BSAInput;
